
import MarkdownContent from '../components/MarkdownContent';
import about from '../data/about.md';

const Home: React.FC = () => {
   return (
     <MarkdownContent content={require("../data/about.md")}/>
   );
};
export default Home;